export default "__VITE_ASSET__dizsnlsR__"